import React from "react";


function ResidenciesHeader() {

    return (
        <>
            <div className="pd-header">
                <div className="pd-thumb2" style={{ position: "relative" }}>
                    <img src={`${process.env.PUBLIC_URL}images/residencies_banner.png`} alt="Self-guided residencies" />
                </div>

                <div className="header-bottom">
                    <h2 className="pd-title">Self-directed Residencies at CAMP</h2>
                </div>
            </div>
        </>
    );
}

export default ResidenciesHeader;
